import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { UseLogoutProps } from './props';
import { useMutation } from '@tanstack/react-query';
import { fetchLogout } from './service';
import { useLogoutCallback } from '@/hooks/useLogoutCallback';
import { ErrorService } from '@starsoft/common/services';

export function useLogout(options?: UseLogoutProps) {
  const { customOnError } = options ?? {};
  const callback = useLogoutCallback();

  function onSuccess() {
    callback();
  }

  function onError(error: AxiosError<GenericError>) {
    ErrorService.onError(error);
    customOnError?.(error);
  }

  const { mutate, isPending, error } = useMutation({
    onError,
    onSuccess,
    mutationFn: fetchLogout,
  });

  return {
    mutate,
    isLoading: isPending,
    error,
  };
}
